<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="6" class="text-right">
          <v-menu
            bottom
            v-model="filter_menu"
            :close-on-content-click="false"
            content-class="elevation-0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                <v-icon size="22px">mdi-filter-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item>
                  <v-autocomplete
                    dense
                    flat
                    :items="project_work"
                    outlined
                    label="Project Type"
                    hide-details
                    small
                    class="body-2"
                    placeholder="Project Type"
                    clearable
                    v-model="project_work_type"
                    @change="getProjectByStatus();"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item>
                  <v-col cols="5" style="padding: 0px;">
                    <v-autocomplete
                      dense
                      flat
                      :items="project_type"
                      outlined
                      label="Type"
                      hide-details
                      small
                      class="body-2"
                      placeholder="All"
                      clearable
                      v-model="project_type_value"
                      @change="getProjectByStatus();updateRange();"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7">
                    <v-autocomplete
                      dense
                      flat
                      :items="project_list_filter"
                      item-text="p_name"
                      item-value="project_id"
                      outlined
                      label="Project"
                      hide-details
                      small
                      class="body-2"
                      placeholder="All"
                      clearable
                      v-model="task_project_id"
                      @change="updateRange();"
                    ></v-autocomplete>
                  </v-col>
                </v-list-item>
                <v-list-item>
                  <v-autocomplete
                    dense
                    :items="assign_type_list"
                    v-model="assign_type"
                    outlined
                    hide-details
                    clearable
                    label="Type"
                    @change="updateRange()"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item>
                  <v-autocomplete
                    dense
                    :items="assign_list"
                    v-model="assign_id"
                    outlined
                    hide-details
                    clearable
                    :label="assign_type"
                    @change="updateRange()"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false;project_work_type='';task_project_id='';"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3" class="text-right">
          <v-tooltip bottom v-if="task_project_id && project_work">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="header_btn"
                @click="task_project_id=task_project_id ;openTaskList();filter_menu = false"
              >
                <v-badge color="error">
                  <span class="lable_class">Calendar Task</span>
                  <v-icon size="28px" class>mdi-calendar-clock</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Calendar Task</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3" class="text-right">
          <span class="white--text font-weight-bold">
            Calendar
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-row class="my-6" justify="center" no-gutters>
      <v-card elevation="8" shaped tile class="col-11">
        <v-sheet height="64">
          <v-toolbar flat>
            <!-- <v-col cols="2" style="padding-top  :0px;padding-bottom:0px;">
              <v-autocomplete
                dense
                :items="project_list"
                v-model="project_id"
                outlined
                hide-details
                clearable
                label="Project"
                @change="task_project_id=project_id;updateRange()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" style="padding-top  :0px;padding-bottom:0px;">
              <v-autocomplete
                dense
                :items="assign_type_list"
                v-model="assign_type"
                outlined
                hide-details
                clearable
                label="Type"
                @change="updateRange()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" style="padding-top  :0px;padding-bottom:0px;">
              <v-autocomplete
                dense
                :items="assign_list"
                v-model="assign_id"
                outlined
                hide-details
                clearable
                :label="assign_type"
                @change="updateRange()"
              ></v-autocomplete>
            </v-col>-->

            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Today</v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>

            <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-menu bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  style="margin-left:15px;"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>-->
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>

            <!-- <v-col col="1" style="text-align:end">
              <v-btn class="header_btn" icon dark @click="calendar_task_report=true;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="28px" v-bind="attrs" v-on="on" color="#757575">mdi-printer</v-icon>
                    <span class="lable_class">Report</span>
                  </template>
                  <span>Report</span>
                </v-tooltip>
              </v-btn>
            </v-col>-->
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="addCalendarTaskModal();"
            @click:date="addCalendarTaskModal();"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <!-- <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
                </v-btn>-->
                <v-toolbar-title>
                  <span>{{selectedEvent.name}}</span>
                  <br />
                  <span :style="{ fontSize: '12px' }">{{selectedEvent.start_date}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  color="error"
                  x-small
                  class="custom-close-btn"
                  @click="selectedOpen = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <!-- <v-btn icon   @click:event="showAssign"> 
                <v-icon>mdi-account</v-icon>
                </v-btn>-->
                <!-- <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>-->
              </v-toolbar>
              <v-card-text>
                <span :style="{ fontSize: '12px' }">
                  <b>Project : {{selectedEvent.project? selectedEvent.project.p_name :''}}</b>
                </span>
                <br />
                <span class="pt-2" v-html="selectedEvent.task_note"></span>
                <v-row dense class="light-green lighten-4 primary--text mt-2">
                  <v-col
                    cols="12"
                    class="pt-2"
                    v-for="(assign, index) in selectedEvent.assign_list"
                    :key="index"
                  >
                    <span class="ml-2">{{ assign.name }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">Cancel</v-btn>
              </v-card-actions>-->
            </v-card>
          </v-menu>
        </v-sheet>
      </v-card>
    </v-row>
    <CalendarReport
      :calendar_task_report="calendar_task_report"
      :project_id="task_project_id"
      :assign_type="assign_type"
      :project_detail="project_detail"
      :assign_id="assign_id"
      :task_list="events"
      :start_time="start_time"
      :end_time="end_time"
      :assign_name="assign_name"
      @updateValue="focus='';updateRange();calendar_task_report=false;"
    />
    <TaskList :vendor_list="vendor_list" :user_list="users" />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import CalendarReport from "../calendar/CalendarReport.vue";
import { mapMutations, mapState } from "vuex";
import TaskList from "../task/TaskList";
export default {
  data: () => ({
    focus: "",
    type: "month",
    search_menu: "",
    search: "",
    filter_menu: false,
    project_type: [
      { text: "Only Task", value: "only_task" },
      { text: "All", value: "all" }
    ],
    project_type_value: "only_task",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    project_list: [],
    assign_type_list: [
      { text: "Customer", value: "customer" },
      { text: "User", value: "user" },
      { text: "Vendor", value: "vendor" }
    ],
    project_work: [
      { text: "New Construction", value: "new_construction" },
      { text: "Remodeling", value: "remodeling" },
      { text: "General Invoice", value: "retail_sales" },
      { text: "Counter Tops", value: "counter_tops" }
    ],
    project_work_type: "",
    project_list_filter: [],
    assign_list: [],
    vendor_list: [],
    users: [],
    project_detail: {},
    task_project_id: "",
    assign_id: "",
    assign_type: "",
    selectedAssign: false,
    calendar_task_report: false,
    start_time: "",
    end_time: "",
    assign_name: "",
    main_item: {}
  }),
  computed: {
    ...mapState("task", ["task_list_modal", "refresh_task_list"]),
    ...mapState("addtask", ["add_calendar_task_modal", "p_name", "c_name"])
  },
  components: {
    CalendarReport,
    TaskList
  },
  methods: {
    ...mapMutations("task", ["setTaskData"]),
    ...mapMutations("addtask", ["setAddTaskData"]),

    addCalendarTaskModal(c_task_id, unique_id) {
      var _self = this;
      this.setAddTaskData({ key: "p_id", value: _self.task_project_id });
      this.setAddTaskData({ key: "type_module", value: 8 });
      this.setAddTaskData({ key: "add_calendar_task_modal", value: true });
      this.setAddTaskData({ key: "calendar_selected_date", value: this.focus });
      this.setAddTaskData({ key: "c_task_id", value: c_task_id });
      this.setAddTaskData({ key: "unique_id", value: unique_id });
    },

    showDateTaskPopup({ date }) {
      // this.focus = date;
      // this.type = "day";
      this.start_time = date;
      this.end_time = date;
      this.getCalendarTaskList();
      this.calendar_task_report = true;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    // showEvent({ nativeEvent, event }) {
    //   const open = () => {
    //     this.selectedEvent = event;
    //     this.selectedElement = nativeEvent.target;
    //     requestAnimationFrame(() =>
    //       requestAnimationFrame(() => (this.selectedOpen = true))
    //     );
    //   };
    //   if (this.selectedOpen) {
    //     this.selectedOpen = false;
    //     requestAnimationFrame(() => requestAnimationFrame(() => open()));
    //   } else {
    //     open();
    //   }
    //   nativeEvent.stopPropagation();
    // },

    showEvent({ event }) {
      this.selectedEvent = event;
      if (this.selectedEvent.o_id) {
        this.task_project_id = this.selectedEvent.o_id;
      }

      this.addCalendarTaskModal(
        this.selectedEvent.c_task_id,
        this.selectedEvent.unique_id
      );
    },

    updateRange() {
      let _self = this;
      _self.start_time = _self.$refs.calendar.lastStart.date;
      _self.end_time = _self.$refs.calendar.lastEnd.date;
      _self.getProjectByStatus();
      _self.getCalendarTaskList();
    },

    getCalendarTaskList() {
      let _self = this;
      let new_events = [];
      axios
        .get(
          "calendar_module_task_list?start_time=" +
            _self.start_time +
            "&end_time=" +
            _self.end_time +
            "&project_id=" +
            _self.task_project_id +
            "&type=" +
            _self.assign_type +
            "&assign_id=" +
            _self.assign_id +
            "&assign_name=" +
            _self.assign_name
        )
        .then(function(res) {
          if (res.data.status) {
            let data = res.data.data;
            new_events = data.map(function(item) {
              let assign_list = [];
              item.timed = true;
              item.start = new Date(item.start_date);
              item.end = new Date(item.start_date);
              item.name = item.task.task;

              for (let key in item.customer_task_assignment) {
                assign_list.push({
                  user_type_id: item.customer_task_assignment[key].user_type_id,
                  id: item.customer_task_assignment[key].id,
                  name: item.customer_task_assignment[key].first_name
                });
              }
              for (let key in item.vendor_task_assignment) {
                assign_list.push({
                  user_type_id: item.vendor_task_assignment[key].user_type_id,
                  id: item.vendor_task_assignment[key].id,
                  name: item.vendor_task_assignment[key].v_name
                });
              }
              for (let key in item.user_task_assignment) {
                assign_list.push({
                  user_type_id: item.user_task_assignment[key].user_type_id,
                  id: item.user_task_assignment[key].id,
                  name: item.user_task_assignment[key].first_name
                });
              }
              item.assign_list = assign_list;
              return item;
            });
            _self.events = new_events;
            _self.getAssignList();

            if (_self.assign_id != "" && _self.assign_type != "") {
              _self.getAssignName();
            }
          }
        })
        .catch(function() {});
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },
    getProjectByStatus() {
      let _self = this;
      _self.loading = true;
      _self.cancelSearch();
      _self.cancelSource = axios.CancelToken.source();
      axios
        .get(
          "get_project_by_task?start_time=" +
            _self.start_time +
            "&end_time=" +
            _self.end_time +
            "&project_type=" +
            _self.project_type_value +
            "&project_work_type=" +
            _self.project_work_type,
          { cancelToken: this.cancelSource.token }
        )
        .then(response => {
          if (response.data.status) {
            _self.project_list_filter = response.data.data;
            _self.setAddTaskData({
              key: "project_list",
              value: response.data.data
            });
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getAssignList() {
      let _self = this;
      this.loading = true;
      if (_self.task_project_id) {
        axios
          .get(
            "calendar_module_assign_list?start_time=" +
              _self.start_time +
              "&end_time=" +
              _self.end_time +
              "&project_id=" +
              _self.task_project_id +
              "&type=" +
              _self.assign_type
          )
          .then(response => {
            if (response.data.status) {
              _self.assign_list = response.data.data;
            }
            _self.loading = false;
          })
          .catch(function() {
            _self.loading = false;
          });
      }
    },

    getAssignName() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_project_assign_name?project_id=" +
            _self.task_project_id +
            "&type=" +
            _self.assign_type +
            "&assign_id=" +
            _self.assign_id
        )
        .then(response => {
          if (response.data.status) {
            _self.assign_name = response.data.assign_name;
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    // getProjectList() {
    //   let _self = this;
    //   _self.loading = true;
    //   axios
    //     .get(
    //       "get_project_list_with_work_type?project_work_type=" +
    //         _self.project_work_type
    //     )
    //     .then(response => {
    //       if (response.data.status) {
    //         _self.project_list_filter = response.data.data.projects;
    //         _self.setAddTaskData({
    //           key: "project_list",
    //           value: response.data.data.projects
    //         });
    //       }
    //       _self.loading = false;
    //     })
    //     .catch(function() {
    //       _self.loading = false;
    //     });
    // },
    openTaskList() {
      if (this.task_project_id) {
        let item = this.project_list_filter.filter(item => {
          if (item.project_id == this.task_project_id) {
            return item;
          }
        });
        this.main_item = item[0];
        this.setTaskData({ key: "task_list_modal", value: true });
        this.setTaskData({ key: "type", value: 8 });
        this.setTaskData({ key: "o_id", value: this.main_item.project_id });
        this.setTaskData({ key: "item", value: this.main_item });
        this.setTaskData({ key: "form_name", value: "Project" });
        this.setTaskData({ key: "item_name", value: "" });
        this.setTaskData({ key: "job_name", value: "" });
        this.setTaskData({ key: "user_name", value: "" });
        if (this.main_item.customer) {
          this.setTaskData({
            key: "customer_name",
            value: this.main_item.customer.full_name
          });
        } else {
          this.setTaskData({ key: "customer_name", value: "" });
        }
        this.setTaskData({ key: "bank_name", value: "" });
        this.setTaskData({ key: "project_name", value: this.main_item.p_name });
        this.setTaskData({ key: "vendor_name", value: "" });
      }
    },
    getVendors() {
      let _self = this;
      axios
        .get("get_vendors")
        .then(response => {
          if (response.data.status) {
            (this.vendor_list = response.data.data),
              _self.setAddTaskData({
                key: "vendor_list",
                value: response.data.data
              });
          }
        })
        .catch(function() {});
    },
    getUsers() {
      let _self = this;
      axios
        .get("get_users")
        .then(response => {
          if (response.data.status) {
            this.users = response.data.data;
            _self.setAddTaskData({
              key: "user_list",
              value: response.data.data
            });
          }
        })
        .catch(function() {});
    },
    getTasks() {
      let _self = this;
      axios
        .get("get_tasks")
        .then(response => {
          if (response.data.status) {
            _self.setAddTaskData({
              key: "task_list",
              value: response.data.data
            });
          }
        })
        .catch(function() {});
    }
  },

  mounted() {
    this.getProjectByStatus();
    this.$refs.calendar.checkChange();
    // this.getProjectList();
    this.getVendors();
    this.getUsers();
    this.getTasks();
  }
};
</script>
<style>
.v-btn--fab.v-size--small {
  /* height: 30px !important;
  width: 30px !important; */
}
.v-size--default {
  height: 27px !important;
}
.v-toolbar__title {
  font-size: 1rem;
}
.v-event-summary {
  color: black !important;
}
</style>
